// @flow

import React, { type Node } from 'react';
import styled, { keyframes } from 'styled-components';
import LoadingWowWrapper from './loading-wow-wrapper';

const pulse = keyframes`
  0% {
    transform: scale(0);
    color: #2397d4;
  }
  75%, 100% {
    transform: scale(4);
    color: transparent;
  }
`;

const pulseColor = keyframes`
  50%, 90% {
    color: #2397d4;
  }
  70% {
    color: #91cbea;
  }
`;

const LoadingIndicator = styled.div`
  position: relative;
  border-radius: 50%;
  background-color: currentColor;
  width: 16px;
  height: 16px;
  color: #2397d4;

  animation: ${pulseColor} 3s ease infinite;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    color: #2397d4;
    background-color: currentColor;
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 50%;
    transition: all 1s;
    animation: ${pulse} 3s ease-out infinite;
  }

  &::after {
    animation-delay: 400ms;
    animation-timing-function: cubic-bezier(0.3, 1.65, 0.7, -0.65);
  }
`;

type Props = {|
  pageCentered?: boolean,
  componentCentered?: boolean,
|};

export function LoadingWow({ pageCentered = false, componentCentered = false }: Props): Node {
  return (
    <LoadingWowWrapper pageCentered={pageCentered} componentCentered={componentCentered}>
      <LoadingIndicator />
    </LoadingWowWrapper>
  );
}
